/** @prettier */
import { connect } from 'react-redux';
import Breadcrumbs from '../../../components/event/Breadcrumbs';

function mapStateToProps(state) {
  return {
    tags: state.getIn(['navigation', 'tags']),
    product: state.getIn(['application', 'product']),
  };
}

export default connect(mapStateToProps)(Breadcrumbs);
